/** 审核页步骤配置 */
export const approveHiddenStepKeys = ['strategy', 'price']

export const approveChecklist = [
  {
    key: 'basic',
    step: 1,
    title: '基本信息',
    hint: '请检查电站的基本信息是否配置正常',
  },
  {
    key: 'device',
    step: 2,
    title: '电站设备',
    hint: '检查所有设备的 SN/UUID 准确无误',
  },
  {
    key: 'topo',
    step: 3,
    title: '电站拓扑',
    hint: '检查电站拓扑图是否正确反映了电气连接',
  },
  {
    key: 'strategy',
    step: 4,
    title: '运行策略',
    hint: '检查运行策略的时段与参数符合业务需求',
  },
  {
    key: 'price',
    step: 5,
    title: '电价',
    hint: '检查电价信息是否已准确配置',
  },
]

/** 审核向导当前展示的步骤（暂时不含运行策略、电价） */
export const approveChecklistVisible = approveChecklist
  .filter((item) => !approveHiddenStepKeys.includes(item.key))
  .map((item, index) => ({ ...item, step: index + 1 }))
